import React from "react";
import { RefreshCw } from "lucide-react";

function fmt(ts) {
  if (!ts) return "necunoscut";
  const d = new Date(ts);
  return d.toLocaleString("ro-RO", { dateStyle: "short", timeStyle: "short" });
}

export default function DataFreshnessBadge({ timestamp, ttlSeconds = 3600, onRefresh }) {
  const ageMs = timestamp ? Date.now() - new Date(timestamp).getTime() : null;
  const stale = ageMs != null && ageMs > ttlSeconds * 1000;
  const veryStale = ageMs != null && ageMs > ttlSeconds * 1000 * 2;
  const color = veryStale ? "text-red-600 border-red-500/50 bg-red-500/10" : stale ? "text-amber-700 border-amber-500/50 bg-amber-500/10" : "text-emerald-700 border-emerald-500/40 bg-emerald-500/10";

  return (
    <div
      data-testid="data-freshness-badge"
      className={`inline-flex items-center gap-2 rounded border px-2 py-1 text-xs ${color}`}
    >
      <span>Date la {fmt(timestamp)}</span>
      {onRefresh ? (
        <button
          data-testid="data-freshness-refresh"
          type="button"
          onClick={onRefresh}
          className="inline-flex items-center gap-1 rounded border border-slate-200 px-1.5 py-0.5 hover:bg-slate-100"
        >
          <RefreshCw size={12} /> Refresh
        </button>
      ) : null}
    </div>
  );
}
